import axiosInstance from "./axiosInstance";
import { axiosInstanceFast } from "./axiosInstance";
import axios from "axios";
import { getCookie } from "@utils/utils";
import { entityDataParamsProps } from "@pages/homepage/asset-auto-discovery/assetAutoDiscoveryTypes";
import {
  // UpdateAssetListType,
  UpdateAssetListTypeNew,
} from "@pages/homepage/asset-auto-discovery/AssetAutoDiscovery";

export const getStatusFilter = async (
  data: {
    filterTime: string;
    filterType: string;
    filterSubType?: string;
  },
  signal?: AbortSignal,
) => {
  // const response = await axiosInstance.post('/statusfilter/', data);
  const response = await axiosInstanceFast.post("/entity/status-filter", data, {
    signal,
  });
  return response.data.data;
};

export const getAssetAdditionalData = async (
  filterTime: string = "day",
  signal?: AbortSignal,
) => {
  const response = await axiosInstance.post(
    "/assetAutoDiscovery/",
    {
      filterType: "assetAutoDiscovery",
      filterTime,
    },
    { signal },
  );
  return response.data;
};

export const getAllAssetData = async (
  filterTime: string = "day",
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/entity/all-data",
    {
      filterTime,
    },
    { signal },
  );
  return response.data.data;
};

export const getEntityList = async (
  data: entityDataParamsProps,
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post("/entity/entities", data, {
    signal,
  });
  return response.data.data;
};

export const getWatchList = async (
  filter_time: string = "day",
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.get("/entity/get-watch-list", {
    params: { filter_time },
    signal,
  });
  return response.data.data;
};

// export const getEntityConnctionsData = async (
//   macAddress: string,
//   filterTime: string = "day",
//   type: string = "all",
// ) => {
//   // const response = await axiosInstance.post('/entity/entity-connections/',{ mac, filterTime, type})
//   const response = await axiosInstanceFast.post("/entity/entity-connections", {
//     filterTime,
//     macAddress,
//     type,
//   });
//   return response.data.data;
// };

export const getEntityConnctionsData = async (
  macAddress: string,
  ipAddress: string,
  subnet: string,
  filterTime: string = "day",
  type: string,
  signal?: AbortSignal,
) => {
  // const response = await axiosInstance.post('/entity/entity-connections/',{ mac, filterTime, type})
  const response = await axiosInstanceFast.post(
    "/entity/entity-connections",
    {
      filterTime,
      macAddress,
      ipAddress,
      subnet,
      type,
    },
    { signal },
  );
  // const dummyData = {
  //     "subnets": [
  //         "172.16.120.0"
  //     ],
  //     "lastInternetIp": "239.255.255.250",
  //     "hostname": "SLDXB-AMITCH",
  //     "hostcons": [
  //         {
  //             "subnet": "172.16.120.0",
  //             "mac": "08:00:27:cb:7e:f5",
  //             "entityType": "Computer",
  //             "hostThreatScore": 0,
  //             "dport": 0,
  //             "hostname": "KALI",
  //             "type": "normal",
  //             "entityIp": "172.16.120.119"
  //         },
  //         {
  //             "entityType": "subnet",
  //             "hostname": "172.16.120.0",
  //             "altname": "Local N/w"
  //         },
  //         {
  //             "entityType": "subnet",
  //             "hostname": "172.16.110.0",
  //             "altname": ""
  //         },
  //         {
  //             "subnet": "172.16.120.0",
  //             "mac": "7e:1a:47:89:a8:7c",
  //             "entityType": "Mobile",
  //             "hostThreatScore": 6,
  //             "dport": 0,
  //             "hostname": "",
  //             "type": "normal",
  //             "entityIp": "172.16.120.119"
  //         },
  //         {
  //             "subnet": "172.16.120.0",
  //             "mac": "dc:71:96:6d:e4:3a",
  //             "entityType": "Computer",
  //             "hostThreatScore": 32,
  //             "dport": 0,
  //             "hostname": "LSDXB-LINOYXPS",
  //             "type": "threat",
  //             "entityIp": "172.16.120.58"
  //         },
  //         {
  //             "subnet": "172.16.120.0",
  //             "mac": "",
  //             "entityType": "",
  //             "hostname": "",
  //             "entityIp": "172.16.120.88",
  //             "type": "prediction",
  //             "path": [
  //                 {
  //                     "device": "172.16.118.254",
  //                     "v_system": "vsys1"
  //                 }
  //             ],
  //             "allowed_app": [
  //                 "ftp",
  //                 "http",
  //                 "smtp",
  //                 "telnet",
  //                 "ssh",
  //                 "dns",
  //                 "tftp"
  //             ]
  //         },

  //     ],
  //     "ip": "172.16.120.50",
  //     "entityType": "Computer",
  //     "hasinternet": 1,
  //     "mac": macAddress
  // }

  // const dummyData = {
  //   "mac": "00:0c:29:4e:4d:b9",
  //   "entityType": "Computer",
  //   "hostname": null,
  //   "ip": "172.16.6.38",
  //   "lastInternetIp": "172.16.1.247",
  //   "hasInternet": null,
  //   "subnets": [
  //     "172.16.6.0",
  //     "172.16.1.0",
  //     "172.16.7.0",
  //     "172.16.119.0"
  //   ],
  //   "hostcons": [
  //     {
  //       "mac": "00:0c:29:22:f5:db",
  //       "entityIp": "172.16.6.33",
  //       "dport": 135,
  //       "hostname": "",
  //       "entityType": null,
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.6.0"
  //     },
  //     {
  //       "hostname": "172.16.6.0",
  //       "entityType": "subnet",
  //       "alt-name": "172.16.1.0"
  //     },
  //     {
  //       "mac": "00:8e:73:90:77:c2",
  //       "entityIp": "172.16.1.252",
  //       "dport": 161,
  //       "hostname": "",
  //       "entityType": null,
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.6.0"
  //     },
  //     {
  //       "mac": "00:8e:73:90:79:c1",
  //       "entityIp": "172.16.1.249",
  //       "dport": 161,
  //       "hostname": "",
  //       "entityType": "Server",
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.6.0"
  //     },
  //     {
  //       "mac": "50:08:ac:b4:32:c2",
  //       "entityIp": "172.16.1.248",
  //       "dport": 161,
  //       "hostname": "",
  //       "entityType": null,
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.6.0"
  //     },
  //     {
  //       "hostname": "172.16.1.0",
  //       "alt-name": "172.16.1.0",
  //       "entityType": "subnet"
  //     },
  //     {
  //       "mac": "50:08:ac:ca:55:c2",
  //       "entityIp": "172.16.1.246",
  //       "dport": 161,
  //       "hostname": "",
  //       "entityType": null,
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.6.0"
  //     },
  //     {
  //       "mac": "00:0c:29:cf:57:f9",
  //       "entityIp": "172.16.6.48",
  //       "dport": 0,
  //       "hostname": "",
  //       "entityType": null,
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.6.0"
  //     },
  //     {
  //       "mac": "d4:f5:ef:90:a8:b4",
  //       "entityIp": "172.16.6.20",
  //       "dport": 0,
  //       "hostname": "",
  //       "entityType": null,
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.6.0"
  //     },
  //     {
  //       "mac": "00:0c:29:9d:6d:40",
  //       "entityIp": "172.16.6.76",
  //       "dport": 445,
  //       "hostname": "",
  //       "entityType": null,
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.6.0"
  //     },
  //     {
  //       "mac": "00:0c:29:f8:65:2f",
  //       "entityIp": "172.16.6.72",
  //       "dport": 135,
  //       "hostname": "",
  //       "entityType": null,
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.6.0"
  //     },
  //     {
  //       "mac": "00:0c:29:0c:71:91",
  //       "entityIp": "172.16.7.9",
  //       "dport": 135,
  //       "hostname": "",
  //       "entityType": null,
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.6.0"
  //     },
  //     {
  //       "mac": "00:8e:73:90:75:c2",
  //       "entityIp": "172.16.1.253",
  //       "dport": 161,
  //       "hostname": "",
  //       "entityType": null,
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.6.0"
  //     },
  //     {
  //       "mac": "34:db:fd:db:78:c7",
  //       "entityIp": "172.16.1.247",
  //       "dport": 161,
  //       "hostname": "",
  //       "entityType": null,
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.6.0"
  //     },
  //     {
  //       "hostname": "172.16.7.0",
  //       "alt-name": "172.16.7.0",
  //       "entityType": "subnet"
  //     },
  //     {
  //       "mac": "00:0c:29:9d:95:52",
  //       "entityIp": "172.16.6.235",
  //       "dport": 0,
  //       "hostname": "",
  //       "entityType": null,
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.1.0"
  //     },
  //     {
  //       "mac": "00:86:9c:37:b7:12",
  //       "entityIp": "172.16.6.57",
  //       "dport": 2050,
  //       "hostname": "",
  //       "entityType": "Network Device",
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.1.0"
  //     },
  //     {
  //       "mac": "00:0c:29:26:1c:48",
  //       "entityIp": "172.16.6.236",
  //       "dport": 0,
  //       "hostname": "",
  //       "entityType": null,
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.1.0"
  //     },
  //     {
  //       "mac": "8c:f8:c5:c2:0b:7d",
  //       "entityIp": "172.16.119.45",
  //       "dport": 0,
  //       "hostname": "SLDXB-SHAHAN",
  //       "entityType": "Computer",
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.1.0"
  //     },
  //     {
  //       "mac": "ea:50:8e:05:4c:96",
  //       "entityIp": "172.16.119.45",
  //       "dport": 0,
  //       "hostname": "",
  //       "entityType": null,
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.1.0"
  //     },
  //     {
  //       "hostname": "172.16.119.0",
  //       "alt-name": "172.16.119.0",
  //       "entityType": "subnet"
  //     },
  //     {
  //       "mac": "00:0c:29:19:3c:8d",
  //       "entityIp": "172.16.6.98",
  //       "dport": 0,
  //       "hostname": "",
  //       "entityType": null,
  //       "type": "normal",
  //       "hostThreatScore": 0,
  //       "subnet": "172.16.6.0"
  //     }
  //   ]
  // }
  return response.data.data;
  // return dummyData;
};

export const getnonDHCPEntityList = async (
  data: entityDataParamsProps,
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/entity/non-dhcp-entities",
    data,
    { signal },
  );
  return response.data.data;
};

export const getHostDetailsData = async (
  mac?: string,
  filterTime?: string,
  watched?: boolean,
  signal?: AbortSignal,
  ipAddress?: string,
) => {
  // const response = await axiosInstance.post('/hostdetails/',{ mac: mac, filterTime: filterTime })
  // return response.data;
  //TODO - Later on change the username dynamically and isAdmin based on the user
  const response = await axiosInstanceFast.post(
    "/entity/host-details",
    {
      macAddress: mac,
      filterTime: filterTime,
      watched: watched,
      userName: "lsadmin",
      isAdmin: 0,
      ipAddress,
    },
    { signal },
  );
  return response.data.data;
};

export const entityAction = async (data: {
  macAddress: string;
  watched?: number;
  whitelistMac?: number;
  whitelistIp?: number;
  critical?: number;
  userName: string;
  isAdmin: number;
}) => {
  const response = await axiosInstanceFast.post("/entity/host-details", data);
  return response.data.data;
};

export const getEntityUserSessions = async (
  macAddress: string,
  filterTime: string = "day",
  signal?: AbortSignal,
  type?: string,
) => {
  const response = await axiosInstanceFast.post(
    "/entity/entity-user-sessions",
    { macAddress, filterTime, type },
    { signal },
  );
  return response.data.data;
};

export const getEntityVulnerabilities = async (
  macAddress: string,
  ipAddress?: string,
  filterTime: string = "day",
  type?: string,
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/entity/entity-vulnerabilities",
    { macAddress, ipAddress, filterTime, type },
    { signal },
  );
  return response.data.data;
};

export const getEntityNonADUsers = async (
  macAddress: string,
  filterTime: string = "day",
  signal?: AbortSignal,
  type?: string,
) => {
  const response = await axiosInstanceFast.post(
    "/entity/entity-non-ad-users",
    {
      macAddress,
      filterTime,
      type,
    },
    { signal },
  );
  return response.data.data;
};

export const editEntity = async (data: {
  name: string;
  value: string;
  pk: string;
}) => {
  const response = await axiosInstance.post("/editEntity/", data);
  return response.data;
};

export const updateEntityAttribute = async (data: any) => {
  const response = await axiosInstanceFast.put(
    "/entity/update-attributes/",
    data,
  );
  return response.data.data;
};

export const getEntityStatsData = async (
  macAddress: string,
  filterTime: string = "day",
  type: string,
  signal?: AbortSignal,
) => {
  // const response = await axiosInstance.post('/entityStats/',{ "mac": macAddress, "filterTime": filterTime })
  // return response.data;
  const response = await axiosInstanceFast.post(
    "/entity/entity-stats",
    {
      macAddress,
      filterTime,
      type,
    },
    { signal },
  );
  return response.data.data;
};

const typeMap: { [key: string]: string } = {
  topMacVendors: "macVendor",
  topAnomalies: "anomalyType",
  topSubnets: "subnet",
  topDomainCategories: "domainCategory",
  applications: "app",
  outdatedApps: "app",
  tld: "tld",
  topServices: "service",
  topDomains: "domain",
};
const getEndStepTimeFromString = (
  str: string,
): { end: number; step: number } => {
  let end = 0;
  let step = 2;

  switch (str) {
    case "day":
      end = 24;
      step = 2;
      break;
    case "3day":
      end = 72;
      step = 4;
      break;
    case "7day":
      end = 168;
      step = 8;
      break;
    case "month":
      end = 720;
      step = 15;
      break;
    case "2month":
      end = 1440;
      step = 20;
      break;
  }

  return { end, step };
};

const numberRange = (
  start: number,
  end: number,
  step: number = 1,
): number[][] => {
  const range: number[][] = [];
  for (let i = start; i < end; i += step) {
    range.push([i, i + step]);
  }
  return range;
};
async function apiCallLoop(
  url: string,
  payload: any,
  numberArray: number[][],
): Promise<any> {
  const responseData: any[] = [];
  // const allVal: string[] = [];
  const allVal: any = {};
  const headers = {
    "X-CSRFToken": getCookie("csrftoken"),
    "Content-Type": "application/json",
  };
  for (const n of numberArray) {
    url = process.env.FASTAPI_URL + `/entity/assets-drilldown-by-widget/`;
    const response = await axios.post(
      url,
      { ...payload, timeIndex: n.toString() },
      {
        headers,
        withCredentials: true,
      },
    );
    // console.log(response.data.data, "hello world")
    for (const dict of response.data.data) {
      // if (!allVal.includes(dict["mac"])) {
      //   allVal.push(dict["mac"]);
      //   responseData.push(dict);
      // }
      if (allVal[dict["mac"]]) {
        if ("count" in dict) {
          allVal[dict["mac"]]["count"] += dict["count"];
        }
        if ("value" in dict) {
          allVal[dict["mac"]]["value"] += dict["value"];
        }
      } else {
        allVal[dict["mac"]] = dict;
        responseData.push(dict);
      }
      // responseData.push(dict)
    }
    // responseData = responseData.concat(response.data.data)
  }
  responseData.forEach((element) => {
    if ("count" in element) {
      element["count"] = allVal[element["mac"]]["count"];
    }
    if ("value" in element) {
      element["value"] = allVal[element["mac"]]["value"];
    }
  });

  // console.log(responseData, "ashhhhhh")
  return responseData;
}
export const getWidgetDrillDownData = async (
  timeFrame: string = "day",
  widget: string,
  type: string,
  version?: string,
) => {
  const typeKey = typeMap[widget];
  const payload: { timeFrame: string; widget: string; [key: string]: string } =
    {
      timeFrame,
      widget,
    };
  payload[typeKey] = type;
  if (widget == "outdatedApps" && version) {
    payload["version"] = version;
  }
  let url = "/entity/assets-drilldown-by-widget/";
  if (widget == "topServices") {
    url = "/entity/assets-by-service/";
    payload["service"] = type;
  } else if (
    widget == "topDomains" ||
    widget == "topDomainCategories" ||
    widget == "tld"
  ) {
    const start = 0;

    const stepAndEnd = getEndStepTimeFromString(timeFrame);
    const end = stepAndEnd["end"];
    const step = stepAndEnd["step"];
    const numberArray: number[][] = numberRange(start, end, step);
    const responsecall = await apiCallLoop(url, payload, numberArray);
    // for (const n of numberArray) {
    //     url = `/assetsDrilldownByWidget/${n}/`
    //     // url = `/assetsDrilldownByWidget/0,2/`
    //     let responsecall =  apiCallEchLoop(url, payload)
    //     // const response =  await axios.post(url,payload);
    //     responseData = responseData.concat(responsecall)
    //     console.log(responsecall)
    // }
    return responsecall;
  }
  // const headers = { 'X-CSRFToken': getCookie('csrftoken'), 'Content-Type': 'application/json' };
  const response = await axiosInstanceFast.post(url, payload);
  return response.data.data;
};

// ------------------------#LS2026--------------------------------------------------------
// export const updateAssetList = async (data:UpdateAssetListType) => {
//   const response = await axiosInstance.post("/AddUpdateMultipleAssetCategory/",
//      data,
//     {
//       headers: {
//         'X-CSRFToken': getCookie('csrftoken'),
//         'Content-Type': 'application/json'
//     },
//     withCredentials: true,
//     }
//   );
//   return response.data;
// };

export const deleteEntityAsset = async (data: {
  id: number;
  macAddress: string;
}) => {
  const response = await axiosInstanceFast.delete("/entity/delete/", {
    data: { id: data.id, macAddress: data.macAddress, isSoftDelete: false },
  });
  return response.data;
};

export const entityTimeSeriesAttribute = async (data: {
  pastHours: number;
  macAddress: string;
}) => {
  const response = await axiosInstanceFast.post(
    "/entity/get-entity-timeseries-attribute",
    {
      pastHours: data.pastHours,
      macAddress: data.macAddress,
    },
  );

  return response.data;
};

export const updateAssetList = async (data: UpdateAssetListTypeNew[]) => {
  const response = await axiosInstanceFast.put(
    "/entity/update-entity-attributes/",
    data,
  );
  return response.data;
};

export const assetAutoDiscoveryEntities = async (
  filterTime: string = "day",
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/entity/assetAutoDiscoveryEntities/",
    {
      filterTime,
    },
    { signal },
  );
  return response.data.data;
};

export const getEntitySummary = async () => {
  const response = await axiosInstanceFast.get("/entity/entity-summary/");
  return response.data.data;
};

export const getEntityExternalLogs = async (
  data: {
    macAddress?: string;
    filterTime: string;
    type: string;
    ipAddress?: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/entity/entity-deny-logs/",
    data,
    { signal },
  );
  return response.data.data;
};
// ---------------------------------------------------------------------------------------

export const fetchPluginsByCategory = async (cat: string) => {
  const response = await axiosInstanceFast.get(
    "/plugin/plugin-categories-frontend/" + cat + "/",
  );
  return response.data.data;
};

export const fetchPluginDetails = async (
  pluginId: string,
  pluginName: string,
  functionName: string,
  filterTime: string,
) => {
  const response = await axiosInstanceFast.post(
    `plugin/${pluginId}/data/${functionName}?fileName=main&functionName=${functionName}`,
    { timeframe: filterTime },
  );
  return { [pluginName]: response.data };
};

export const getEntityConnectionAllData = async (
  macAddress: string,
  filterTime: string,
  ipAddress: string,
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    `/entity/entity-connections-all`,
    { macAddress, filterTime, ipAddress },
    { signal },
  );
  return response.data.data;
};

export const getEntityFlowSummaryData = async (
  data: {
    filterTime: string;
    macAddress?: string;
    ipAddress?: string;
    subnet?: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    `/entity/entity-flow-summary`,
    data,
    { signal },
  );
  return response.data.data;
};
